const updateScreenSize = ( size ) => ( {
    type: 'UDATE_SCREEN_SIZE',
    size,
} );

export  {
    updateScreenSize,
};
